/** 세션 최대 유효 시간: 1시간(초) */
export const SESSION_MAX_SECONDS = 60 * 60;

/**
 * 로그인/연장 시 사용: "지금부터 1시간 후" 만료 타임스탬프(ms)
 * @returns {number} Unix timestamp (ms)
 */
export function getOneHourExpiry() {
  return Date.now() + SESSION_MAX_SECONDS * 1000;
}
